import { createContext, useContext } from "react";

const SettingsReadOnlyContext = createContext(false);

export const useSettingsReadOnly = () => useContext(SettingsReadOnlyContext);

export default SettingsReadOnlyContext;
